<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ data.title }}</h1>

<div mat-dialog-content class="mbp-confirm-dialog__content waybill-dialog__content">
  @if (order && sageUiEnabled) {
    <div class="waybill-dialog__sage-row">
      <span>Sage: {{ getSageSyncLabel() }}</span>
      @if (order.sage_invoice_id) {
        <span> ({{ order.sage_invoice_id }})</span>
      }
      <button type="button" mat-stroked-button class="waybill-dialog__btn" (click)="syncOrderToSage()">
        <mat-icon>sync_alt</mat-icon> Sync to Sage
      </button>
    </div>
  }

  @if (!waybillWasCaptured) {
    <mat-stepper linear #stepper class="waybill-dialog__stepper">
      <mat-step [stepControl]="senderAddressForm">
        <form [formGroup]="senderAddressForm">
          <ng-template matStepLabel>Collection address</ng-template>

          <p class="waybill-dialog__intro">
            Enter the collection address where the courier will pick up the parcel.
          </p>

          <div class="row g-2">
            <div class="col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>City</mat-label>
                <input type="text" formControlName="city" matInput />
                @if (senderAddressForm.get('city')?.invalid) {
                  <mat-error>City is invalid, should have a maximum of 30 characters</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Street</mat-label>
                <input required type="text" formControlName="street" matInput />
                @if (senderAddressForm.get('street')?.invalid) {
                  <mat-error>Street is invalid, should have a maximum of 30 characters</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Building complex name</mat-label>
                <input type="text" formControlName="buildingComplexName" matInput />
                @if (senderAddressForm.get('buildingComplexName')?.invalid) {
                  <mat-error>Building complex name is invalid</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Postal code</mat-label>
                <input type="text" formControlName="postalCode" matInput />
                @if (senderAddressForm.get('postalCode')?.invalid) {
                  <mat-error>Postal code is invalid</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Work tel</mat-label>
                <input required type="text" formControlName="workTel" matInput />
                @if (senderAddressForm.get('workTel')?.invalid) {
                  <mat-error>Work tel is invalid</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>Suburb</mat-label>
                <input required type="text" formControlName="surburb" matInput />
                @if (senderAddressForm.get('surburb')?.invalid) {
                  <mat-error>Suburb is invalid, should have a maximum of 30 characters</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Building number</mat-label>
                <input type="number" min="1" formControlName="buildingNumber" matInput />
                @if (senderAddressForm.get('buildingNumber')?.invalid) {
                  <mat-error>Building number is invalid</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Unit</mat-label>
                <input type="number" min="1" formControlName="unit" matInput />
                @if (senderAddressForm.get('unit')?.invalid) {
                  <mat-error>Unit is invalid</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Contact person</mat-label>
                <input required type="text" formControlName="contactPerson" matInput />
                @if (senderAddressForm.get('contactPerson')?.invalid) {
                  <mat-error>Contact person is invalid</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </form>

        <div class="waybill-dialog__footer">
          <button
            type="button"
            class="waybill-dialog__btn--primary"
            [disabled]="senderAddressForm.invalid"
            mat-flat-button
            color="primary"
            matStepperNext
          >
            <mat-icon>chevron_right</mat-icon> Next
          </button>
        </div>
      </mat-step>

      <mat-step [stepControl]="deliveryAddressForm">
        <form [formGroup]="deliveryAddressForm">
          <ng-template matStepLabel>Delivery address</ng-template>

          <p class="waybill-dialog__intro">
            Enter the delivery address where the parcel should be delivered.
          </p>

          <div class="row g-2">
            <div class="col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>City</mat-label>
                <input type="text" formControlName="city" matInput />
                @if (deliveryAddressForm.get('city')?.invalid) {
                  <mat-error>City is invalid, should have a maximum of 30 characters</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Street</mat-label>
                <input required type="text" formControlName="street" matInput />
                @if (deliveryAddressForm.get('street')?.invalid) {
                  <mat-error>Street is invalid, should have a maximum of 30 characters</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Building complex name</mat-label>
                <input type="text" formControlName="buildingComplexName" matInput />
                @if (deliveryAddressForm.get('buildingComplexName')?.invalid) {
                  <mat-error>Building complex name is invalid</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Postal code</mat-label>
                <input type="text" formControlName="postalCode" matInput />
                @if (deliveryAddressForm.get('postalCode')?.invalid) {
                  <mat-error>Postal code is invalid</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Cell number</mat-label>
                <input required type="text" formControlName="cell" matInput />
                @if (deliveryAddressForm.get('cell')?.invalid) {
                  <mat-error>Cell number is invalid</mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-md-6">
              <mat-form-field appearance="outline">
                <mat-label>Suburb</mat-label>
                <input required type="text" formControlName="surburb" matInput />
                @if (deliveryAddressForm.get('surburb')?.invalid) {
                  <mat-error>Suburb is invalid, should have a maximum of 30 characters</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Building number</mat-label>
                <input type="number" min="1" formControlName="buildingNumber" matInput />
                @if (deliveryAddressForm.get('buildingNumber')?.invalid) {
                  <mat-error>Building number is invalid</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Unit</mat-label>
                <input type="number" min="1" formControlName="unit" matInput />
                @if (deliveryAddressForm.get('unit')?.invalid) {
                  <mat-error>Unit is invalid</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Contact person</mat-label>
                <input required type="text" formControlName="contactPerson" matInput />
                @if (deliveryAddressForm.get('contactPerson')?.invalid) {
                  <mat-error>Contact person is invalid</mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Company</mat-label>
                <input type="text" formControlName="company" matInput />
                @if (deliveryAddressForm.get('company')?.invalid) {
                  <mat-error>Company is invalid</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </form>

        <div class="waybill-dialog__footer">
          <button type="button" class="waybill-dialog__btn" mat-stroked-button matStepperPrevious>
            <mat-icon>chevron_left</mat-icon> Previous
          </button>
          <button
            type="button"
            class="waybill-dialog__btn--primary"
            [disabled]="deliveryAddressForm.invalid"
            mat-flat-button
            color="primary"
            matStepperNext
          >
            <mat-icon>chevron_right</mat-icon> Next
          </button>
        </div>
      </mat-step>

      <mat-step [stepControl]="serviceTypeForm">
        <ng-template matStepLabel>Add parcels</ng-template>

        <p class="waybill-dialog__intro">
          Select a service type and add one or more parcels for this waybill.
        </p>

        <form [formGroup]="serviceTypeForm" class="waybill-dialog__service-form">
          <mat-form-field appearance="outline">
            <mat-label>Service type</mat-label>
            <mat-select required formControlName="type">
              @for (type of serviceTypes; track type) {
                <mat-option [value]="type.code">{{ type.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>

        <div class="waybill-dialog__section">
          <h2 class="waybill-dialog__section-title">Add parcel</h2>
          <core-add-parcel (onAddParcel)="addParcel($event)" [waybillNo]="waybillNo"></core-add-parcel>
        </div>

        <div class="waybill-dialog__section">
          <h2 class="waybill-dialog__section-title">Added parcels</h2>
          <core-parcel-list [parcels]="parcels" (onDelete)="deleteParcel($event)"></core-parcel-list>
        </div>

        <div class="waybill-dialog__footer">
          <button type="button" class="waybill-dialog__btn" mat-stroked-button matStepperPrevious>
            <mat-icon>chevron_left</mat-icon> Previous
          </button>
          <button
            type="button"
            class="waybill-dialog__btn--primary"
            [disabled]="parcels.length === 0"
            mat-flat-button
            color="primary"
            (click)="prepareWaybill()"
          >
            <mat-icon>chevron_right</mat-icon> Next
          </button>
        </div>
      </mat-step>

      <mat-step (interacted)="hideNext = !hideNext">
        <ng-template matStepLabel>Review</ng-template>

        <p class="waybill-dialog__intro">
          Review the waybill details before capturing.
        </p>

        @if (waybillPayload) {
          <core-waybill-review [waybillPayload]="waybillPayload"></core-waybill-review>
        }

        <div class="waybill-dialog__footer">
          <button type="button" class="waybill-dialog__btn" mat-stroked-button matStepperPrevious>
            <mat-icon>chevron_left</mat-icon> Previous
          </button>
          <button
            type="button"
            class="waybill-dialog__btn--primary"
            [disabled]="!waybillPayload || isLoading"
            mat-flat-button
            color="primary"
            (click)="captureWaybill()"
          >
            Capture waybill
          </button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Complete</ng-template>

        <p class="waybill-dialog__intro">
          Your waybill has been captured. Download the shipping labels below.
        </p>

        <div class="waybill-dialog__label-actions">
          @for (link of labelLinks; track link) {
            <button type="button" class="waybill-dialog__btn" mat-stroked-button (click)="viewLabel(link)">
              <mat-icon>open_in_new</mat-icon> Download label
            </button>
          }
        </div>
      </mat-step>
    </mat-stepper>
  }
</div>

<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions waybill-dialog__actions">
  <button type="button" mat-stroked-button class="waybill-dialog__btn" [mat-dialog-close]="false">Cancel</button>
  <button
    type="button"
    mat-flat-button
    color="primary"
    class="waybill-dialog__btn--primary"
    [disabled]="!waybillCompleted"
    [mat-dialog-close]="true"
  >
    Done
  </button>
</div>
